import { SvgIcon } from '@/common/components/SvgIcon'

const ListCloseIcon = () => <SvgIcon name="square-minus" width={16} height={16} className="text-brand-red" />

export default ListCloseIcon
